let authGeneration = 0;
export const getAuthSessionGeneration = () => authGeneration;

function bridge() {
  return typeof window !== 'undefined' && window.electronAPI && window.electronAPI.authSession;
}

export function saveAuthSession(tokens) {
  authGeneration++;
  sessionStorage.setItem('accessToken', tokens.accessToken);
  sessionStorage.setItem('refreshToken', tokens.refreshToken);
  const api = bridge();
  if (api) {
    const result = api.save({ tenantKey: localStorage.getItem('tenantKey'),
      accessToken: tokens.accessToken, refreshToken: tokens.refreshToken });
    if (result && result.error) console.warn(result.error);
  }
}

export function clearAuthSession() {
  authGeneration++;
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('refreshToken');
  const api = bridge();
  if (api) api.clear();
}

export function hasRestorableAuthSession(tenantKey) {
  const saved = bridge()?.read(tenantKey);
  return Boolean(saved?.accessToken && saved?.refreshToken);
}

// A restored access token is refreshed by the normal HTTP single-flight flow on 401.
// Keep the encrypted session on transient network failure; only definitive auth failure clears it.
export function restoreAuthSession(tenantKey) {
  if (sessionStorage.getItem('accessToken')) return false;
  const api = bridge();
  if (!api) return;
  const saved = api.read(tenantKey);
  if (saved && saved.accessToken && saved.refreshToken) {
    authGeneration++;
    sessionStorage.setItem('accessToken', saved.accessToken);
    sessionStorage.setItem('refreshToken', saved.refreshToken);
    return true;
  }
  return false;
}
